import {ProjectService} from "./project.service";
import {Component} from "@angular/core";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {ConfirmDialogService} from "../confirm-dialog/confirm-dialog-service";
import {handleErrors} from "../misc/handle-errors.decorator";

@Component({
  selector: "project",
  templateUrl: "./project-show.template.pug",
  providers: [
    ProjectService,
    ConfirmDialogService,
  ],
})

export class ProjectComponent extends RouteHelper {
  error: Error;
  id: string;
  project: any;

  paramsMap: RouteMapping[] = [
    {fieldName: "id", paramName: "id"} as RouteMapping,
  ];

  userTypes: {key: string, text: string}[] = [
    {key: "transitionLeads", text: "Transition Lead(s): "},
    {key: "accountLeads", text: "Account Lead(s): "},
    {key: "pursuitLead", text: "Pursuit Lead(s): "},
    {key: "discoveryDesignLead", text: "Discovery and Design Lead(s): "},
    {key: "contractAdministrator", text: "Contract Administrator(s): "},
    {key: "productSupportSpecialist", text: "Product Support Specialist(s): "},
  ];

  @handleErrors()
  async loadData(): Promise<any> {
    const {rows} = await this.projectService.getProjects("0", "1", `id:${this.id}`, false);
    this.project = rows[0] || {};
  }

  navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["project"], {queryParams, skipLocationChange});
  }

  @handleErrors()
  async remove() {
    const warningParts = [];

    if (this.project.siteCount) warningParts.push(`${this.project.siteCount} site(s)`);
    if (this.project.plannedDevices) warningParts.push(`${this.project.siteCount} assets(s)`);
    if (this.project.orderCount) warningParts.push(`${this.project.siteCount} orders(s)`);
    if (this.project.deploymentCount) warningParts.push(`${this.project.siteCount} deployments(s)`);

    const warning = warningParts.length ? ` The following will be deleted: ${warningParts.join(", ")}.` : "";

    const message = `Are you sure you want to delete this project?${warning}`;
    const result = await this.confirmDialogService.confirm("Confirm", message);

    if (result) {
      await this.projectService.remove(this.project.id).toPromise();
      await this.router.navigate(["/projects"]);
    }
  }

  @handleErrors()
  async purge() {
    const result = await this.confirmDialogService.confirm(
      "Confirm project deletion",
      "Are you sure you want to delete this project? This will override all safety checks and is irreversible.",
    );

    if (result) {
      await this.projectService.purge(this.project.id);
      await this.router.navigate(["/projects"]);
    }
  }

  @handleErrors()
  async unassignMeToProject() {
    const res = await this.projectService.unAssignUserToProject(this.project.id).toPromise();
    if (res && res.success) {
      await this.router.navigate(["/projects"]);
    }
  }

  @handleErrors()
  public async geoRegionChanged(project) {
    await this.projectService.updateGeoRegion(project.id, project.geoRegionId);
    project.geo_region_id = project.geoRegionId; // eslint-disable-line @typescript-eslint/camelcase
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private projectService: ProjectService,
    private confirmDialogService: ConfirmDialogService,
  ) {
    super();

    this.project = {};
  }
}
